import {Pipeline,} from '../types';
import {PlatformPropertyCard, PlatformPropertyCardEntryInput} from "@flexinet/ui-components";
import {Stack} from '@mantine/core';
import {PipelineStatusBadge} from '../components/PipelineStatusBadge';


export const Profile = ({record}: { record: Pipeline }) => {

    const properties: PlatformPropertyCardEntryInput[] = [
        {
            label: 'Name',
            value: record.name as string,
            span: 12,
        }, {
            label: 'Description',
            value: record.description as string,
            span: 12,
        }, {
            label: 'Status',
            value: <PipelineStatusBadge status={record.pipelineStatus}/>,
            span: 12,
        }, {
            label: 'Pipeline Type',
            value: record.pipelineType as string,
            span: 12,
        }, {
            label: 'Template',
            value: record.template?.name || 'n/a',
            span: 12,
        }, {
            label: 'Template Archetype',
            value: record.template?.archetype || 'n/a',
            span: 12,
        }, {
            label: 'Code Repository',
            value: record.codeRepositoryName as string,
            span: 12,
        }, {
            label: 'Branch',
            value: record.branchName || 'n/a',
            span: 12,
        }, {
            label: 'Build Command',
            value: record.buildCommand || 'n/a',
            span: 12,
        }, {
            label: 'Original Stack Name',
            value: record.originalStackName || 'n/a',
            span: 12,
        }, {
            label: 'Stack Name',
            value: record.stackName || 'n/a',
            span: 12,
        }];

    const properties2: PlatformPropertyCardEntryInput[] = [
        {
            label: 'Created By',
            value: record.createdByUsername || 'n/a',
            span: 12,
        },
        {
            label: 'Managed By',
            value: record.managedByUsername || 'n/a',
            span: 12,
        },
        {
            label: 'Created',
            value: record.created as string,
            formatter: 'timestamp',
            span: 12,
        },
        {
            label: 'Last Updated',
            value: record.updated as string,
            formatter: 'timestamp',
            span: 12,
        }];

    return (
        <Stack gap={'xl'}>
            <PlatformPropertyCard properties={properties}/>
            <PlatformPropertyCard properties={properties2}/>
        </Stack>
    );


};
